<div class="popup__wrap">
  <div class="popup">
    <div class="onboard">

      <ion-slides class="onboard-slider" #slider pager="true">
        <ion-slide>
          <div class="onboard__item onboard--1">
            <div class="clouds">
              <img src="/assets/img/chmorka-1.svg" alt="" class="img-resp">
            </div>
            <div class="onboard-1__animation">
              <img src="/assets/img/tadek-onboarding-1.svg" alt="" class="tadek">
            </div>
            <p>Jestem Twoim przewodnikiem <br>
              po nowościach w programie<br>
              Starterem po nagrody</p>

            <ion-button (click)="nextSlide_click()">Dalej</ion-button>
          </div>
        </ion-slide>
        <ion-slide>
          <div class="onboard__item onboard--2">

            <div class="clouds">
              <img src="/assets/img/chmorka-2.svg" alt="" class="img-resp">
            </div>
            <div class="onboard__item__animation">
              <img src="/assets/img/tadek-onboarding-2.svg" alt="" class="tadek tadek--2">
            </div>
            <p>Klikaj, rozwiązuj quizy<br>
              i zagadki</p>

            <ion-button (click)="nextSlide_click()">Dalej</ion-button>
          </div>
        </ion-slide>
        <ion-slide>
          <div class="onboard__item onboard--3">

            <div class="clouds">
              <img src="/assets/img/chmorka-3.svg" alt="" class="img-resp">
            </div>
            <div class="onboard__item__animation">
              <img src="/assets/img/tadek-onboarding-3.svg" alt="" class="tadek tadek--3">

            </div>
            <p>Codziennie czekają na Ciebie <br>
              nagrody pieniężne</p>

            <ion-button (click)="nextSlide_click()">Dalej</ion-button>
          </div>
        </ion-slide>
        <ion-slide>
          <div class="onboard__item onboard--4">

            <div class="clouds">
              <img src="/assets/img/chmurka-4.svg" alt="" class="img-resp">
            </div>
            <div class="onboard__item__animation">
              <img src="/assets/img/tadek-onboarding-4.svg" alt="" class="tadek tadek--4">

            </div>
            <p>Upoluj szczęśliwe bonusy<br/> kilka razy na kwartał</p>

            <ion-button (click)="closeSlider_click()">Zamknij</ion-button>
          </div>
        </ion-slide>
      </ion-slides>

    </div>
  </div>
</div>
